module.exports = __webpack_public_path__ + "img/title9.7efdbd3c.jpg";